import {connect} from 'react-redux';
import PropertyTypesComponent from './PropertyTypes';
import {fetchImagesByTags} from './redux';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {TABLET_BREAKPOINT} from '../../utils/constants';
import {
    ACTION_LOCATION,
    pushHandlerClickData,
    pushHandleNextData,
    pushHandlePrevData,
} from './events';

const mapStateToProps = (state) => {
    const {
        abacus = {},
        config: {url: {basePathPrefix} = {}, isRefined} = {},
        options: {removePropertyTypesRefined, removePropertyTypesUnrefined},
        modules: {
            pageHeadings: {showNewHeadings, propertyTypesHeading} = {},
        } = {},
        propertyTypes = {},
    } = state;

    return {
        propertyTypes,
        showNewHeadings,
        basePathPrefix,
        abacus,
        propertyTypesHeading,
        isRefined,
        removePropertyTypesRefined,
        removePropertyTypesUnrefined,
        ACTION_LOCATION,
        pushHandlerClickData,
        pushHandleNextData,
        pushHandlePrevData,
    };
};

const mapDispatchToProps = {
    fetchImagesByTags,
};

export const PropertyTypes = connect(
    mapStateToProps,
    mapDispatchToProps
)(determineIfMobile(PropertyTypesComponent, TABLET_BREAKPOINT));

PropertyTypes.displayName = 'PropertyTypes';

export default PropertyTypes;
